import React, { useLayoutEffect } from "react";

export default function NotFoundPage() {
    useLayoutEffect(() => {
        document.body.classList.add("is-not-found-page");
        return () => {
            document.body.classList.remove("is-not-found-page");
        };
    }, []);

    return (
        <div className="not-found-page">
            <h1 className="not-found-page__code">404</h1>
            <p className="not-found-page__text">Страница не найдена</p>
        </div>
    );
}
